import {Alert, Group, Stack, Text} from '@mantine/core'
import {format} from 'date-fns'

import {parseApiDate} from 'src/jobs/job-schedule-format'

import {ConfirmOutButton} from './confirm-out-button'

export type UnconfirmedRental = {
    rentalStintId: string
    unit: string
    since: string
}

type ConfirmOutPanelProps = {
    rentals: UnconfirmedRental[]
    canConfirm: boolean
    onConfirmed?: () => void
}

/** Lists a job's equipment that went on rent automatically and dispatch has not confirmed. */
export function ConfirmOutPanel({rentals, canConfirm, onConfirmed}: ConfirmOutPanelProps) {
    if (rentals.length === 0) {
        return null
    }

    return (
        <Alert color="orange" variant="light" title="Not confirmed" data-testid="confirm-out">
            <Stack gap="xs">
                <Text size="sm">
                    {canConfirm
                        ? 'Went on rent automatically. Confirm each unit went out, or record its return.'
                        : 'Went on rent automatically. Dispatch confirms each unit went out.'}
                </Text>
                {rentals.map((rental) => (
                    <Group key={rental.rentalStintId} justify="space-between" gap="sm">
                        <Text size="sm">
                            {rental.unit} · on rent since{' '}
                            {format(parseApiDate(rental.since), 'MMM d')}
                        </Text>
                        {canConfirm ? (
                            <ConfirmOutButton
                                rentalStintIds={[rental.rentalStintId]}
                                onConfirmed={onConfirmed}
                            />
                        ) : null}
                    </Group>
                ))}
                {canConfirm && rentals.length > 1 ? (
                    <Group justify="flex-end">
                        <ConfirmOutButton
                            rentalStintIds={rentals.map((rental) => rental.rentalStintId)}
                            label="Confirm all"
                            onConfirmed={onConfirmed}
                        />
                    </Group>
                ) : null}
            </Stack>
        </Alert>
    )
}
